import { render } from "./Logo.vue?vue&type=template&id=2aa10161"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=2aa10161&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__